import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Add this helper function for getting week number
declare global {
  interface Date {
    getWeek(): number;
  }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateRandomString(
  length = 8,
  charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
) {
  let result = '';
  const charsetLength = charset.length;

  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charsetLength));
  }

  return result;
}

Date.prototype.getWeek = function () {
  const date = new Date(this.getTime());
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  const week1 = new Date(date.getFullYear(), 0, 4);
  return (
    1 +
    Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7)
  );
};

/**
 * Converts a tenant name to a domain format
 * Replaces whitespace with dashes and makes the entire string lowercase
 * @param tenantName - The tenant name to convert
 * @returns The domain-formatted string
 */
export function tenantNameToDomain(tenantName: string): string {
  return tenantName.toLowerCase().replace(/\s+/g, '-');
}

/**
 * Creates an email address from an employee ID and tenant name
 * @param employeeId - The employee ID
 * @param tenantName - The tenant name to convert to domain format
 * @returns The formatted email address
 */
export function createEmployeeEmail(employeeId: string, tenantName: string): string {
  const domain = tenantNameToDomain(tenantName);
  return `${employeeId}@${domain}.com`;
}

export function titleCase(str: string): string {
  return str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export const downloadPDF = (pdfBuffer: Uint8Array, filename: string) => {
  const blob = new Blob([pdfBuffer], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
